import { Validators } from '@angular/forms';
import {
  DeliveryControls,
  DeliveryErrors,
  DirectDebitControls,
  DirectDebitErrors,
} from '@dgx-pr-spa/shared/util';
import {
  CheckboxToggleDef,
  ControlType,
  FieldDef,
  RadioDef,
  SelectDef,
  TextInputDef,
} from '@domgen/dgx-fe-dynamic-form-builder';

export const firstAvailableDateFieldDef: TextInputDef = {
  controlName: DeliveryControls.FirstAvailableDate,
  controlType: ControlType.INPUT,
  validators: [],
  validationMessages: [],
  label: { text: 'First Available Date' },
  initialValue: '',
  placeholder: 'First Available Date',
  type: 'text',
};

export const expectedDateFieldDef: TextInputDef = {
  controlName: DeliveryControls.ExpectedDate,
  controlType: ControlType.INPUT,
  validators: [],
  validationMessages: [],
  label: { text: 'Expected Date' },
  initialValue: '',
  placeholder: 'Expected Date',
  type: 'text',
};

export const addressLine1FieldDef: TextInputDef = {
  controlName: DeliveryControls.AddressLine1,
  controlType: ControlType.INPUT,
  validators: [],
  validationMessages: [],
  label: { text: 'Address line 1' },
  initialValue: '',
  placeholder: 'Address line 1',
  type: 'text',
  sanitise: 'block',
};

export const addressLine2FieldDef: TextInputDef = {
  controlName: DeliveryControls.AddressLine2,
  controlType: ControlType.INPUT,
  validators: [],
  validationMessages: [],
  label: { text: 'Address line 2' },
  initialValue: '',
  placeholder: 'Address line 2',
  type: 'text',
  sanitise: 'block',
};

export const addressLine3FieldDef: TextInputDef = {
  controlName: DeliveryControls.AddressLine3,
  controlType: ControlType.INPUT,
  validators: [],
  validationMessages: [],
  label: { text: 'Address line 3' },
  initialValue: '',
  placeholder: 'Address line 3',
  type: 'text',
  sanitise: 'block',
};

export const addressLine4FieldDef: TextInputDef = {
  controlName: DeliveryControls.AddressLine4,
  controlType: ControlType.INPUT,
  validators: [],
  validationMessages: [],
  label: { text: 'Address line 4' },
  initialValue: '',
  placeholder: 'Address line 4',
  type: 'text',
  sanitise: 'block',
};

export const postCodeFieldDef: TextInputDef = {
  controlName: DeliveryControls.PostCode,
  controlType: ControlType.INPUT,
  validators: [],
  validationMessages: [],
  label: { text: 'Postcode' },
  initialValue: '',
  placeholder: 'Postcode',
  type: 'text',
  sanitise: 'block',
};

export const countryCodeFieldDef: TextInputDef = {
  controlName: DeliveryControls.CountryCode,
  controlType: ControlType.INPUT,
  validators: [],
  validationMessages: [],
  label: { text: 'Country' },
  initialValue: '',
  placeholder: 'Country',
  type: 'text',
  sanitise: 'block',
};

export const emailFieldDef: TextInputDef = {
  controlName: DeliveryControls.Email,
  controlType: ControlType.INPUT,
  validators: [
    Validators.required,
    Validators.pattern(
      /* eslint-disable no-control-regex */
      /^(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-Za-z0-9-]*[A-Za-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/
    ),
  ],
  validationMessages: [
    { type: 'required', message: DeliveryErrors.EmailRequired },
    { type: 'pattern', message: DeliveryErrors.EmailPattern },
  ],
  label: { text: 'Email' },
  initialValue: '',
  placeholder: 'Enter email',
  type: 'text',
  sanitise: 'block',
};

export const mobileValidation = Validators.pattern(
  /* eslint-disable no-useless-escape */
  /^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/
);

export const mobileFieldDef: TextInputDef = {
  controlName: DeliveryControls.Mobile,
  controlType: ControlType.INPUT,
  validators: [Validators.required, mobileValidation],
  validationMessages: [
    { type: 'required', message: DeliveryErrors.MobileRequired },
    { type: 'pattern', message: DeliveryErrors.MobilePattern },
  ],
  label: { text: 'Mobile' },
  initialValue: '',
  placeholder: 'Enter mobile',
  type: 'text',
  sanitise: 'block',
};

export const telephoneFieldDef: TextInputDef = {
  controlName: DeliveryControls.Telephone,
  controlType: ControlType.INPUT,
  validators: [mobileValidation],
  validationMessages: [
    { type: 'required', message: DeliveryErrors.TelephoneRequired },
    { type: 'pattern', message: DeliveryErrors.TelephonePattern },
  ],
  label: { text: 'Telephone' },
  initialValue: '',
  placeholder: 'Enter telephone',
  type: 'text',
  sanitise: 'block',
};

export const isTelephoneOpenFieldDef: TextInputDef = {
  controlName: DeliveryControls.IsTelephoneOpen,
  controlType: ControlType.INPUT,
  validators: [],
  validationMessages: [],
  label: { text: 'Is Telephone Open' },
  initialValue: '',
  placeholder: 'Is telephone open',
  type: 'text',
};

export const accessDifficultiesFieldDef: RadioDef = {
  controlName: DeliveryControls.AccessDifficulties,
  controlType: ControlType.RADIO,
  validators: [Validators.required],
  validationMessages: [
    { type: 'required', message: DeliveryErrors.AccessDifficultiesRequired },
  ],
  initialValue: '',
  label: {
    text: 'Can our driver safely and legally park close to your property?',
  },
  options: [
    {
      label: 'Yes',
      value: 'Yes',
    },
    {
      label: 'No',
      value: 'No',
    },
  ],
};

export const checkSpecFieldDef: RadioDef = {
  controlName: DeliveryControls.CheckSpecFieldDef,
  controlType: ControlType.RADIO,
  validators: [Validators.required],
  validationMessages: [
    { type: 'required', message: DeliveryErrors.CheckSpecRequired },
  ],
  initialValue: '',
  label: {
    text: 'Will the product fit in the space where you want it?',
  },
  options: [
    {
      label: 'Yes',
      value: 'Yes',
    },
    {
      label: 'No',
      value: 'No',
    },
  ],
};

export const productionConnectionFieldDef: RadioDef = {
  controlName: DeliveryControls.ProductionConnectionFieldDef,
  controlType: ControlType.RADIO,
  validators: [Validators.required],
  validationMessages: [
    {
      type: 'required',
      message: DeliveryErrors.ProductionConnectionFieldDefRequired,
    },
  ],
  initialValue: '',
  label: {
    text: 'Are there suitable connections (electric, water or gas) for the product?',
  },
  options: [
    {
      label: 'Yes',
      value: 'Yes',
    },
    {
      label: 'No',
      value: 'No',
    },
  ],
};

export const accessInfoFieldDef: TextInputDef = {
  controlName: DeliveryControls.AccessInfo,
  controlType: ControlType.INPUT,
  validators: [],
  validationMessages: [
    { type: 'required', message: DeliveryErrors.StairsRequired },
  ],
  label: { text: 'Additional Info' },
  initialValue: '',
  type: 'text',
};

export const stairsFieldDef: RadioDef = {
  controlName: DeliveryControls.Stairs,
  controlType: ControlType.RADIO,
  validators: [Validators.required],
  validationMessages: [
    { type: 'required', message: DeliveryErrors.StairsRequired },
  ],
  label: {
    text: 'Will the delivery team have to carry the product up stairs?',
  },
  initialValue: '',
  options: [
    {
      label: 'Yes',
      value: 'Yes',
    },
    {
      label: 'No',
      value: 'No',
    },
  ],
};

export const additionalInfoFieldDef: TextInputDef = {
  controlName: DeliveryControls.AdditionalInfo,
  controlType: ControlType.INPUT,
  validators: [],
  validationMessages: [
    { type: 'required', message: DeliveryErrors.StairsRequired },
  ],
  label: { text: 'Additional Info' },
  initialValue: '',
  type: 'text',
};

export const deliveryFieldset: FieldDef[] = [
  firstAvailableDateFieldDef,
  expectedDateFieldDef,
  addressLine1FieldDef,
  addressLine2FieldDef,
  addressLine3FieldDef,
  addressLine4FieldDef,
  postCodeFieldDef,
  countryCodeFieldDef,
  emailFieldDef,
  mobileFieldDef,
  telephoneFieldDef,
  isTelephoneOpenFieldDef,
  accessDifficultiesFieldDef,
  accessInfoFieldDef,
  stairsFieldDef,
  additionalInfoFieldDef,
  checkSpecFieldDef,
  productionConnectionFieldDef,
];

export const sort1FieldDef: TextInputDef = {
  controlName: DirectDebitControls.Sort1,
  controlType: ControlType.INPUT,
  validators: [Validators.required, Validators.pattern(/^[0-9]{2}$/)],
  label: { text: 'Sort code' },
};

export const sort2FieldDef: TextInputDef = {
  controlName: DirectDebitControls.Sort2,
  controlType: ControlType.INPUT,
  validators: [Validators.required, Validators.pattern(/^[0-9]{2}$/)],
  label: { text: 'Sort code' },
};

export const sort3FieldDef: TextInputDef = {
  controlName: DirectDebitControls.Sort3,
  controlType: ControlType.INPUT,
  validators: [Validators.required, Validators.pattern(/^[0-9]{2}$/)],
  label: { text: 'Sort code' },
};

export const monthlyPaymentFieldDef: TextInputDef = {
  controlName: DirectDebitControls.MonthlyPayment,
  controlType: ControlType.INPUT,
  validators: [],
  validationMessages: [],
  type: 'number',
  classes: 'hidden',
};

export const accountHolderNameFieldDef: TextInputDef = {
  controlName: DirectDebitControls.AccountHolderName,
  controlType: ControlType.INPUT,
  validators: [Validators.required, Validators.pattern(/^[A-Za-z-'\s]+$/)],
  validationMessages: [
    { type: 'required', message: DirectDebitErrors.AccountHolderNameRequired },
    { type: 'pattern', message: DirectDebitErrors.AccountHolderNamePattern },
  ],
  label: { text: 'Name of account holder' },
  placeholder: 'Name of account holder',
  type: 'text',
};

export const accountPostPolicy: CheckboxToggleDef = {
  controlName: DirectDebitControls.PostPolicy,
  controlType: ControlType.CHECKBOX,
  validators: [],
  initialValue: false,
};

export const accountNumberFieldDef: TextInputDef = {
  controlName: DirectDebitControls.AccountNumber,
  controlType: ControlType.INPUT,
  validators: [Validators.required, Validators.pattern(/^[0-9]{8}$/)],
  validationMessages: [
    { type: 'required', message: DirectDebitErrors.AccountNumberRequired },
    { type: 'pattern', message: DirectDebitErrors.AccountNumberPattern },
  ],
  label: { text: 'Account number' },
  placeholder: 'Account number',
  type: 'text',
};

export const preferredPaymentDayFieldDef: SelectDef = {
  controlName: DirectDebitControls.PreferredPaymentDay,
  controlType: ControlType.SELECT,
  validators: [Validators.required],
  initialValue: '01',
  validationMessages: [
    {
      type: 'required',
      message: DirectDebitErrors.PreferredPaymentDayRequired,
    },
  ],
  label: { text: 'Preferred monthly payment day' },
  placeholder: 'Account number',
  options: [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
  ],
};

export const directDebitFieldset: FieldDef[] = [
  accountHolderNameFieldDef,
  accountNumberFieldDef,
  preferredPaymentDayFieldDef,
  monthlyPaymentFieldDef,
  accountPostPolicy,
];

export const sortCodeFieldset: FieldDef[] = [
  sort1FieldDef,
  sort2FieldDef,
  sort3FieldDef,
];
